var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.file && !!_vm.contentOverlayImage)?_c('div',{staticClass:"content-overlay-image-container",staticStyle:{"position":"absolute","overflow":"hidden"},style:({
      width: _vm.file.containDimensions.containWidth + 'px',
      height: _vm.file.containDimensions.containHeight + 'px',
      left: _vm.file.containDimensions.xOffset + 'px',
      top: _vm.file.containDimensions.yOffset + 'px',
    })},[_c('img',{staticStyle:{"position":"absolute","transform-origin":"bottom right"},style:({
        right: _vm.tweakedPosition.x + 'px',
        bottom: _vm.tweakedPosition.y + 'px',
        width:
          _vm.contentOverlayImage.image_width * _vm.containPreviewScaleFactor + 'px',
        height:
          _vm.contentOverlayImage.image_height * _vm.containPreviewScaleFactor + 'px',
        transform: _vm.tweakedTransform,
      }),attrs:{"src":_vm.contentOverlayImage.image_url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GroupContentOverlayImagePreview.vue?vue&type=template&id=01c14ba3&
// module id = 2155
// module chunks = 5